export const checkFormat = (el: any, format?: string) => {
  if (el?.constructor?.name) return false;
  if (el) {
    return format ? el?.split('.')?.pop() === format : el?.split('.')?.pop();
  }
  return false;
};
